import { render } from "./Game.vue?vue&type=template&id=a418b80c"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=a418b80c&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\维西之王\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__